"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactHookForm = require("react-hook-form");
var _propTypes = require("prop-types");
require("./styles.scss");
/* eslint-disable react/no-danger */

var RadioButtonControlled = function RadioButtonControlled(_ref) {
  var control = _ref.control,
    name = _ref.name,
    labelText = _ref.labelText,
    isRequired = _ref.isRequired,
    value = _ref.value;
  var _useController = (0, _reactHookForm.useController)({
      name: name,
      control: control,
      rules: {
        required: isRequired
      },
      defaultValue: ''
    }),
    field = _useController.field;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", Object.assign({
    id: value,
    "aria-labelledby": "radio-label-".concat(labelText),
    type: "radio"
  }, field, {
    name: name,
    value: value
  })), /*#__PURE__*/_react.default.createElement("div", {
    id: "radio-label-".concat(labelText),
    className: "radio-label"
  }, ' ', labelText));
};
RadioButtonControlled.defaultProps = {
  isRequired: false
};
RadioButtonControlled.propTypes = {
  control: (0, _propTypes.shape)({}).isRequired,
  name: _propTypes.string.isRequired,
  labelText: _propTypes.string.isRequired,
  isRequired: _propTypes.bool,
  value: _propTypes.string.isRequired
};
var _default = exports.default = RadioButtonControlled;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-refunds/lib/components/RadioButtonControlled/styles.scss');